
import React from "react";
import "./Form.css";
import ceoImage from "../../img/team7.jpg";

function Form() {
  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent default form submission
    alert("Thank you for contacting us!"); 
    event.target.submit(); 
  };

  return (
    <div className="form-container">
      
      <div className="form-card">
        {/* Left Section: CEO Profile */}
        <div className="left-section">
          <img src={ceoImage} alt="Ethan Johnson" className="profile-img" />
          <div className="profile-info">
            <h3 className="ceo">Customer Relationship Manager</h3>
            <p>
              ✉ contact@sammarshya.com <br />
              ✆ +91-9552461202 <br />
              
              💬 @Sammarshya

             
            </p>
            ⚲ <a
                href="https://maps.app.goo.gl/ut2M2JbSthivT6wW7"
                target="_blank"
                rel="noopener noreferrer"
                className="address-link"
              >  B-Wing, 2nd Floor, Montclaire, India Accelerato, near, Baner - Pashan Link Rd, Baner, Pune, Maharashtra 411021 </a> <br />
          </div>
        </div>

        {/* Right Section: Form */}
        <div className="right-section">
          <h1>Start growing your business with us</h1>
          <form
            action="https://formsubmit.co/contact@sammarshya.com"
            method="POST"
            onSubmit={handleSubmit}
          >
            <div className="form-row">
              <input type="text" name="name" placeholder="Name" required />
            </div>
            <div className="form-row">
              <input type="email" name="email" placeholder="Email" required />
              <input type="tel" name="phone" placeholder="Phone" minLength={10} maxLength={10} required />
            </div>
            <div className="form-row">
              <select name="industry" required>
                <option value="">Industry</option>
                <option value="Real Estate">Real Estate</option>
                <option value="Oil & Gas">Oil & Gas</option>
                <option value="Ecommerce">Ecommerce</option>
                <option value="Logistic">Logistic</option>
                <option value="Fintech">Fintech</option>
                <option value="Healthcare">Healthcare</option>
              </select>
              <input
                type="text"
                name="budget"
                placeholder="Expected Budget"
                required
              />
            </div>
            <textarea
              name="message"
              placeholder="Message"
              rows="2" required
            ></textarea>
            <div className="checkbox">
              <input type="checkbox" id="consent" required />
              <label htmlFor="consent">
                I agree that my personal information will be processed and
                stored by Sammarshya.
              </label>
            </div>
            <input
              type="hidden"
              name="_subject"
              value="New form submission from Sammarshya"
            />
            <button type="submit" className="submit-btn">
              SEND MESSAGE
            </button>
          </form>
        </div>

      </div>
      
    </div>
  );
}

export default Form;
